import { useGetQuoteQuery } from './studioApi'
import type { LessonCount } from './useStartGeneration'

export interface CourseQuoteView {
  /** Цена ЦЕЛОГО прогона из сметы — не `per_lesson × lessonCount`. */
  price?: string
  balance?: string
  isLoading: boolean
}

/**
 * Смета генерации в СУЩЕСТВУЮЩИЙ курс. У него есть id — значит есть и своя
 * ручка сметы; `useNewCourseQuote` тут не при чём, он про случай «курса ещё
 * нет» и ищет чужой id по спискам автора.
 *
 * Лишнего запроса не будет: тот же кеш уже держит `useCourseBusyGate`
 * (`active_job` и цена приезжают одним ответом). `skip` — чтобы свёрнутая
 * панель не тянула смету: показывать её там всё равно негде.
 */
export const useCourseQuote = (
  courseId: number,
  lessonCount: LessonCount,
  skip: boolean,
): CourseQuoteView => {
  const { data, isLoading } = useGetQuoteQuery(courseId, { skip })
  return {
    // Защитное чтение по всей цепочке: нет цены — плашки просто нет
    // (`QuotePlate` это умеет), а не падение панели редактора на неполном
    // ответе. Отсутствие сметы не запрещает запуск — отказ по деньгам
    // разбирается после клика.
    price: data?.course_generation?.options?.[String(lessonCount)],
    balance: data?.balance,
    isLoading: !skip && isLoading,
  }
}
